import React from 'react';

import Calculator from './Calculator';

import './ressources/css/mainstyle.css';

import yourviewsLogo from './ressources/images/logo-yourviews.png';
import sidecontentLeft from './ressources/images/sidecontent-left.png';
import sidecontentRight from './ressources/images/sidecontent-right.png';

export default class Mainpage extends React.Component {

    constructor(props) {
        super(props);

        this.scrollToNps = this.scrollToNps.bind(this);
    }
    
    scrollToNps() {
        window.scrollTo(0, 800);
        let nps = document.getElementById("hi-nps-start");
        nps.scrollIntoView();
    }

    render()  {
        return (
            <main>
                <header>
                    <div className="hi-header-background">
                        <div className="hi-menu">
                            <img
                                src={yourviewsLogo}
                                className="hi-yv-logo"
                                title="Yourviews by Hi Platform"
                                alt="Yourviews by Hi Platform" />
                            <ul>
                                <a
                                    href="https://www.hiplatform.com/sobre"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    <li>Sobre a Hi Platform</li>
                                </a>
                                <a 
                                    href="https://blog.hiplatform.com/"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                        <li>Blog</li>
                                </a>
                                <a 
                                    href="https://www.hiplatform.com/suporte"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                        <li>Suporte</li>
                                </a>
                                <a 
                                    href="https://www.hiplatform.com/contato"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                        <li>Contato</li>
                                </a>
                            </ul>
                        </div>
                        <div className="hi-presentation-info">
                            <span>Net Promoter Score</span>
                            <h3>Calculadora NPS</h3>
                            <p>
                                Simule o NPS da sua empresa, seguindo o passo a passo 
                                abaixo e descubra seus cliente detratores, neutros e promotores, 
                                seu score NPS e sua Zona de Classificação.
                            </p>
                            <button className="hi-regular-button" onClick={this.scrollToNps}>Simular NPS</button>
                        </div>
                    </div>
                </header>
                <section>
                    <Calculator />
                </section>
                <section>
                    <div className="hi-content-box">
                        <h3>Analisando seus resultados</h3>
                        <div className="hi-content-shadow">
                            <img 
                                className="hi-img-box"
                                src={sidecontentLeft}
                                title="O que é NPS"
                                alt="O que é NPS" />
                            <h4>Oque é NPS</h4>
                            <p>
                                Criado em 2003 por Fred Reichheld, o Net Promoter Score 
                                é o metodo mais utilidzado para medir o grau de satisfação e 
                                fidelidade dos clientes de empresas de todos os portes e segmentos
                            </p>
                        </div>
                        <div className="hi-content-shadow">
                            <img
                                className="hi-img-box"
                                src={sidecontentRight}
                                title="Cálculo do NPS"
                                alt="Cálculo do NPS" />
                            <h4>Como o NPS é calculado</h4>
                            <p>
                                O NPS é medido através de uma simples pergunta: 
                                "Em uma escala de 0 a 10, o quanto você indicaria a 
                                nossa empresa para um amigo ou colega?"
                            </p>
                        </div>
                        <div className="center">
                            <div className="hi-example-block blue">NPS</div>
                            <div className="hi-signal-block">=</div>
                            <div className="hi-example-block green">
                                % de Promotores
                                <span>9 e 10</span>
                            </div>
                            <div className="hi-signal-block">-</div>
                            <div className="hi-example-block red">
                                % de Detratores
                                <span>0 até 6</span>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="hi-background-content">
                        <h3 className="white">Fale com um especialista</h3>
                        <button className="hi-regular-button center yellow">
                            <a 
                                href="https://api.whatsapp.com/send?phone=5511971402140&amp;text=Oi%21%20Eu%20quero%20conversar%20com%20um%20especialista%20da%20Hi%20Platform."
                                target="_blank"
                                rel="noopener noreferrer">
                                    Entrar em contato
                            </a>
                        </button>
                    </div>
                </section>
                <section>
                    <div className="hi-content-box">
                        <div className="hi-text-block">
                            <h3>
                                Nível de lealdade e satisfação do cliente entre 
                                Detratores, Neutros e Promotores
                            </h3>
                            <p>
                                O <b>Net Promoter Score (NPS)</b> é uma métrica de lealdade 
                                e satisfação dos clientes com a sua empresa. Um indicador 
                                de satisfação utilizado pelas maiores do mundo que classifica 
                                os clientes entre Promotores, Neutros e Detratores.
                            </p>
                            <p>
                                A valiação d NPS é feita a partir das respostas sobre essa 
                                pergunta, classificando os clientes em três tipos de acordo 
                                com a nota atribuída por eles:
                            </p>
                            <p>
                                <b>- Promotores:</b> São os clientes que dão nota 9 ou 10
                                são leais ou entusiasmados, oferecem feedbacks positivos sobre
                                a marca e auxiliam no crescimento da sua empresa.
                            </p>
                            <p>
                                <b>- Neutros:</b> São os cliente que dão nota 7 ou 8. Não 
                                são entusiasmados e procuram a empresa apenas quando 
                                necessitam, logo, não são clientes fiéis.
                            </p>
                            <p>
                                <b>- Detratores:</b> São os clientes que atribuem uma note 
                                de 0 a 6. Geralmente são clientes que não ficaram satisfeitos 
                                com a marca, expondo feedbacks negativos em público e 
                                provavelmente não voltariam a comprar com a empresa.
                            </p>
                            <h3>
                                Zonas de Classificação NPS 
                                e o que significam
                            </h3>
                            <p>
                                O score obtido varia de -100 a 100 e a partir dele é possível 
                                categorizar a empresa em 4 Zonas de Classificação, de acordo 
                                com a pontuação obtida, evidenciando a relação de satisfção 
                                dos consumidores com a marca. As zonas são divididas em:
                            </p>
                            <p>
                                <span><b>- Zona de Excelencia -</b> NPS entre 75 e 100</span><br />
                                São as empresas que satisfazem os seus clientes, atendendo 
                                às sua expectativas e garantem uma boa experiência ao usuário 
                                Conquistam consumidores fiéis que recomendam e defendem a marca
                            </p>
                            <p>
                                <span><b>- Zona de Qualidade -</b> NPS entre 50 e 74</span><br />
                                Empresas qualificadas nessa zona contam com clientes satisfeitos 
                                com a marca, mas que ressaltam pontos que deixaram a desejar. 
                                Realizar uma valiação da jornada fo ckiente é importante para 
                                que a empresa possa identificar possíveis falhas.
                            </p>
                            <p>
                                <span><b>- Zona de Aperfeiçoamento -</b> NPS entre 0 e 49</span><br />
                                Empresas com score de aperfeiçoamento devem ter muita atenção 
                                com os feedbacks dos seus clientes. Estar situado nesta zona 
                                significa que muitos clientes não tiveram uma boa expperiencia 
                                e não ficaram  satisfeitos com a empresa. Refazer processos, 
                                melhorar estratégias e conhecer melhor as espectativas dos 
                                clientes são pontos importantes a serem avaliados.
                            </p>
                            <p>
                                <span><b>- Zona de Crítica -</b> NPS entre -100 e -1</span><br />
                                Empresas classificadas como Zona Crítica devem tomar ações rápidas 
                                em relação às suas estratégias. Essa categoria indica que muitos clientes 
                                ficaram insatisfeitos com a empresa e que não recomendariam a marca.
                                Eles seram os primeiros a reclamarem de divulgarem feedbacks negativos
                                sobre suas experiências, podendo engajar uma comunidade de outros clientes
                                insatisfeitos a depreciar a marca.
                            </p>
                        </div>
                    </div>
                </section>
            </main>
        );
    }
}